import createModel, { prop } from './lib/create_model';

// TaskTopicChange is a customer-timeline conversation item recording a topic
// association change on a task (backend content type TASK_TOPIC_CHANGE). Mirrors
// ConversationTopicChange with an added taskId so the change can be attributed
// to a specific task.
const TaskTopicChange = createModel({
  modelName: 'TaskTopicChange',

  properties: {
    taskId: prop(String).default(''),
    addedTopics: prop([String]).default([]),
    removedTopics: prop([String]).default([]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default TaskTopicChange;
